// Action Creators
// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
import { PlanLinkTelemetryComponentName } from "@ms/planner-models/lib/local/constants/PlanLinkConstants";
/** Opens the confirmation dialog for disconnecting a task from its linked plan. */ export const openDisconnectPlanModal = (isDisconnectPlanEnabled, sourceTaskId, sourcePlan, planLinkActionCreator, telemetryEntryPoint, engagementLogger, onDismiss)=>{
    if (!isDisconnectPlanEnabled || sourcePlan?.getPlanType() !== PlanType.Unified) {
        return;
    }
    const modalData = {
        modalType: ModalType.DisconnectPlan,
        sourceTaskId,
        telemetryEntryPoint,
        onDismiss
    };
    engagementLogger.logEngagement(PlanLinkTelemetryComponentName, EngagementTelemetryConstants.PLinkEntryPointClicked, {
        operation: "disconnect",
        entryPoint: telemetryEntryPoint
    });
    planLinkActionCreator.openDisconnectPlanModal(modalData);
};
